var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Rule",class:{ center: _vm.center, half: _vm.half, thirds: _vm.thirds, quarter: _vm.quarter },style:('border-bottom-color:' + (_vm.color || '#D8D8D8'))})}
var staticRenderFns = []

export { render, staticRenderFns }